var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c("menu-album", { attrs: { profil: _vm.profil } }),
      _vm._v(" "),
      _c("main", [
        _c("div", { staticClass: "albumMainBody" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "sideMenu__close",
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "profil" })
                }
              }
            },
            [_c("span", { staticClass: "icon" })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "albumList__separator" }),
          _vm._v(" "),
          _c("div", { staticClass: "albumListing__wrap" }, [
            _c("div", { staticClass: "albumList__half --first" }, [
              _c(
                "div",
                {
                  staticClass:
                    "albumList__heading mb-3 d-flex align-items-center justify-content-between"
                },
                [
                  _c("h2", { staticClass: "mb-0" }, [
                    _vm._v("Moje úspechy "),
                    _c("span", {
                      staticClass: "icon --questionMark",
                      on: {
                        click: function($event) {
                          return _vm.$bvModal.show("modalAlbumAnatomia")
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "mb-0" }, [
                    _vm._v("Máš "),
                    _c("span", { staticClass: "--bold" }, [
                      _vm._v(_vm._s(_vm.countOwned))
                    ]),
                    _vm._v(" z celkových "),
                    _c("span", { staticClass: "--bold" }, [
                      _vm._v(_vm._s(_vm.countTotal) + " úspechov")
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.album.uspechy
                ? _c(
                    "div",
                    { staticClass: "albumListing__list" },
                    _vm._l(_vm.album.uspechy, function(uspech, index) {
                      return index >= _vm.startIndex &&
                        index <= _vm.endIndex - 9
                        ? _c(
                            "div",
                            {
                              class:
                                "albumListing__item" +
                                [
                                  uspech.current == uspech.album_uspechy_max &&
                                  uspech.collected == 1
                                    ? " --done"
                                    : uspech.current ==
                                        uspech.album_uspechy_max &&
                                      uspech.collected != 1
                                    ? " --collect"
                                    : ""
                                ],
                              on: {
                                click: function($event) {
                                  return _vm.checkItem(uspech, index)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "albumListing__imageWrap" },
                                [
                                  _c("img", {
                                    staticClass: "img-fluid",
                                    attrs: {
                                      src:
                                        "assets/img/album/uspechy/" +
                                        uspech.album_uspechy_img,
                                      alt: ""
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "albumListing__descriptionWrap"
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "albumListing__name mb-0 --uspechHelp"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(uspech.album_uspechy_nadpis) +
                                          " "
                                      ),
                                      _c("span", {
                                        staticClass: "icon",
                                        attrs: { id: "uspechInfo-" + index }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-popover",
                                    {
                                      attrs: {
                                        target: "uspechInfo-" + index,
                                        triggers: "hover focus",
                                        placement: "top"
                                      }
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(uspech.album_uspechy_popis)
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "albumListing__progress" },
                                    [
                                      _c("span", {
                                        staticClass: "albumListing__bar",
                                        style: {
                                          width:
                                            (uspech.current /
                                              uspech.album_uspechy_max) *
                                              100 +
                                            "%"
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              uspech.collected == 1
                                ? _c("span", {
                                    staticClass: "albumListing__checkmark"
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              uspech.current == uspech.album_uspechy_max &&
                              uspech.collected != 1
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "productGridItem__collect__tag"
                                    },
                                    [_vm._v("Zobrať")]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    }),
                    0
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.album.uspechy
              ? _c("div", { staticClass: "albumList__half --second" }, [
                  _c(
                    "div",
                    { staticClass: "albumListing__list" },
                    _vm._l(_vm.album.uspechy, function(uspech, index) {
                      return index >= _vm.startIndex + 9 &&
                        index <= _vm.endIndex
                        ? _c(
                            "div",
                            {
                              class:
                                "albumListing__item" +
                                [
                                  uspech.current == uspech.album_uspechy_max &&
                                  uspech.collected == 1
                                    ? " --done"
                                    : uspech.current ==
                                        uspech.album_uspechy_max &&
                                      uspech.collected != 1
                                    ? " --collect"
                                    : ""
                                ],
                              on: {
                                click: function($event) {
                                  return _vm.checkItem(uspech, index)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "albumListing__imageWrap" },
                                [
                                  _c("img", {
                                    staticClass: "img-fluid",
                                    attrs: {
                                      src:
                                        "assets/img/album/uspechy/" +
                                        uspech.album_uspechy_img,
                                      alt: ""
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "albumListing__descriptionWrap"
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "albumListing__name mb-0 --uspechHelp"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(uspech.album_uspechy_nadpis) +
                                          " "
                                      ),
                                      _c("span", {
                                        staticClass: "icon",
                                        attrs: { id: "uspechInfo-" + index }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-popover",
                                    {
                                      attrs: {
                                        target: "uspechInfo-" + index,
                                        triggers: "hover focus",
                                        placement: "top"
                                      }
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(uspech.album_uspechy_popis)
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "albumListing__progress" },
                                    [
                                      _c("span", {
                                        staticClass: "albumListing__bar",
                                        style: {
                                          width:
                                            (uspech.current /
                                              uspech.album_uspechy_max) *
                                              100 +
                                            "%"
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              uspech.collected == 1
                                ? _c("span", {
                                    staticClass: "albumListing__checkmark"
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              uspech.current == uspech.album_uspechy_max &&
                              uspech.collected != 1
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "productGridItem__collect__tag"
                                    },
                                    [_vm._v("Zobrať")]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    }),
                    0
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.prevPage != 0
            ? _c(
                "div",
                {
                  staticClass: "albumListing__nav --prev",
                  on: {
                    click: function($event) {
                      return _vm.changePage(_vm.currentPage - 1)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "icon --prev" }),
                  _vm._v("Predchádzajúca strana\n            ")
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.nextPage != 0
            ? _c(
                "div",
                {
                  staticClass: "albumListing__nav --next",
                  on: {
                    click: function($event) {
                      return _vm.changePage(_vm.currentPage + 1)
                    }
                  }
                },
                [
                  _vm._v("\n                Ďalšia strana"),
                  _c("span", { staticClass: "icon --next" })
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalAlbumAnatomia",
          staticClass: "modal fade",
          attrs: {
            id: "modalAlbumAnatomia",
            "hide-footer": "",
            "hide-header": "",
            centered: "",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "modalAlbumAnatomiaTitle",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "b-button",
            {
              staticClass: "m-modalInfo__close",
              attrs: { block: "" },
              on: {
                click: function($event) {
                  return _vm.$bvModal.hide("modalAlbumAnatomia")
                }
              }
            },
            [_c("span", { staticClass: "icon" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body", staticStyle: { padding: "0" } },
            [
              _c("div", { staticClass: "text-center" }, [
                _c("h2", { staticClass: "text-center" }, [_vm._v("Nápoveda")]),
                _vm._v(" "),
                _c("p", { staticClass: "text-18" }, [
                  _vm._v(
                    'Ďakujeme, že sa každý deň dobre staráš o svoju kravičku. Jupí, odteraz ťa za tvoju trpezlivosť a dôslednosť budeme odmeňovať! Každý z úspechov ti po kliknutí na "?" povie, čo musíš urobiť, aby si ho získal. Získaný úspech si tu v albume potvrdíš a dostaneš zaň prekvapko - vecičku do kolekcie, novú časť do anatómie, alebo odomkneš nový mliečny recept.'
                  )
                ])
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalAlbumReward",
          staticClass: "modal fade",
          attrs: {
            id: "modalAlbumReward",
            "hide-footer": "",
            "hide-header": "",
            centered: "",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "modalAlbumRewardTitle",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "b-button",
            {
              staticClass: "m-modalInfo__close",
              attrs: { block: "" },
              on: {
                click: function($event) {
                  return _vm.$bvModal.hide("modalAlbumReward")
                }
              }
            },
            [_c("span", { staticClass: "icon" })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body o-modalInfo" }, [
            _c(
              "div",
              { staticClass: "m-modalLostPassword__content text-center" },
              [
                _c("img", {
                  staticClass: "img-fluid mb-3",
                  attrs: { src: "assets/img/winningPexeso.png", alt: "" }
                }),
                _vm._v(" "),
                _c(
                  "h2",
                  { staticClass: "m-modalWinningPexeso__name text-center" },
                  [_vm._v("Gratulujeme!")]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "text-center m-modalWinningPexeso__text mb-4"
                  },
                  [
                    _vm._v("\n                    Získal si úspech "),
                    _c("strong", [_vm._v(_vm._s(_vm.modal_achievement))]),
                    _vm._v("."),
                    _c("br"),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.modal_reward_text) +
                        " "
                    ),
                    _c("strong", [_vm._v(_vm._s(_vm.modal_reward_nazov))]),
                    _vm._v(".\n                ")
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn --primary",
                      on: {
                        click: function($event) {
                          return _vm.$bvModal.hide("modalAlbumReward")
                        }
                      }
                    },
                    [_vm._v("Pokračovať")]
                  )
                ])
              ]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "albumPages" }, [
      _c("div", { staticClass: "albumPage --first" }),
      _vm._v(" "),
      _c("div", { staticClass: "albumPage --second" }),
      _vm._v(" "),
      _c("div", { staticClass: "albumPage --third" }),
      _vm._v(" "),
      _c("div", { staticClass: "albumPage --fourth" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }